import { DialogContext, useDialogState } from './DialogContext';
import Dialog from '../../component/ui/dialog/Dialog';
import React from 'react';

const DialogProvider = ({ children }) => {
  const dialog = useDialogState();

  return (
    <DialogContext.Provider value={dialog}>
      {children}
      <Dialog />
    </DialogContext.Provider>
  );
};

export default DialogProvider;
